import { CalendarSlot, MeetingStatus } from "../../types";
import { theme } from "../../theme";

export const getCalendarMeetingTypes = (): MeetingStatus[] => {
  return Object.values(MeetingStatus) as MeetingStatus[];
};

export const getCalendarMeetingTypeLabel = (meetingType: MeetingStatus): string => {
  const match = Object.entries(MeetingStatus).find(([, value]) => value === meetingType);
  return match ? match[0] : meetingType;
};

export const getCalendarMeetingTypeColor = (meetingType: MeetingStatus): string => {
  return theme.palette.meetingStatus[meetingType]?.main ?? "#717172";
};

export const getCalendarMeetingColor = (meeting: CalendarSlot): string => {
  return getCalendarMeetingTypeColor(meeting.meetingType);
};